import { takeEvery, call, put, select } from 'redux-saga/effects';
import {
  requestInProcess,
  requestFinished,
  updateList,
  sendRequest,
  selectQueryParams
} from '../../../../../../common/reducers/list/reducer';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import TopUsersService from '../../../../services/TopUsersService';

function* getTopUsersListSaga(reducerName, serviceFunc) {
  yield put(requestInProcess(reducerName));
  const queryParams = yield select(selectQueryParams, reducerName);
  let status = null;
  try {
    const result = yield call(timeoutCall, serviceFunc, queryParams);
    if (result.response) {
      status = result.response.status;
      if (result.response.status === 200) {
        yield put(
          updateList(reducerName, {
            itemsById: result.destructData.itemsById,
            itemsIds: result.destructData.itemsIds
          })
        );
      }
    }
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName, status));
}

export function getSagaTopUsersOfEarningsList(reducerName) {
  return [
    takeEvery(
      sendRequest(reducerName).type,
      getTopUsersListSaga,
      reducerName,
      TopUsersService.getTopUsersOfEarnings
    )
  ];
}

export function getSagaTopUsersOfAdvertisingList(reducerName) {
  return [
    takeEvery(
      sendRequest(reducerName).type,
      getTopUsersListSaga,
      reducerName,
      TopUsersService.getTopUsersOfAdvertising
    )
  ];
}

export function getSagaTopUsersOfExperienceList(reducerName) {
  return [
    takeEvery(
      sendRequest(reducerName).type,
      getTopUsersListSaga,
      reducerName,
      TopUsersService.getTopUsersOfExperience
    )
  ];
}

export function getSagaTopUsersOfReferralsList(reducerName) {
  return [
    takeEvery(
      sendRequest(reducerName).type,
      getTopUsersListSaga,
      reducerName,
      TopUsersService.getTopUsersOfReferrals
    )
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/topUsers/reducers/static/lists/sagas/getTopUsersListSaga.js